export const environment = {
  production: false,
  ApiKey : '72100a7c4c7fa43d880e10226885105d750f1ed7d84f236569f78b608944ee9c',
  ApiEndpoint: 'http://localhost:3010',
  AppBaseUrl: 'http://localhost:4201',
  urlViewDocumentoDian: "https://certificate-vpfe-hab.dian.gov.co/Document/Details?trackId=",
  // ApiDianEndpoind: 'http://localhost:3009/'
  ApiDianEndpoind: 'https://apifacturacionelectronica.mobilsaas.com/'
};
